import { getBonusRoundSeedName } from '../hooks/useDailySeed';
import { archiveRoundsCompletedStorageKey } from './roundsCompletedHelpers';

export const clearArchiveLocalStorage = () => {
  // all rounds
  localStorage.removeItem('archive-guesses'); // country
  localStorage.removeItem(`archive-${getBonusRoundSeedName('shape')}`); // shape
  localStorage.removeItem(`archive-${getBonusRoundSeedName('emblem')}`); // emblem
  localStorage.removeItem(`archive-${getBonusRoundSeedName('capital-flags')}`); // capital
  localStorage.removeItem(`archive-${getBonusRoundSeedName('border-flag')}`); // neighbours
  localStorage.removeItem(`archive-${getBonusRoundSeedName('quiz')}`); // population & currency

  // extras
  localStorage.removeItem(archiveRoundsCompletedStorageKey); // rounds completed
};

export const FIRST_ARCHIVE_DATE = '2024-02-01';
